import React from "react";
import { Link } from "react-router-dom";
import NewsletterForm from "../components/NewsletterForm";
import { BookOpen, Sparkles, Tag, Heart } from "lucide-react";

const PERKS = [
  { icon: BookOpen, title: "Monthly letter", body: "A quiet dispatch on the first Sunday of each month — a new release, a quiet recommendation, a passage we&apos;ve been thinking about." },
  { icon: Tag, title: "Members-only offers", body: "Early access to new titles and the occasional discount kept just for the club." },
  { icon: Sparkles, title: "Free sampler PDFs", body: "Curated chapter samplers from the catalogue, sent twice a year — yours to keep." },
  { icon: Heart, title: "Reader-first", body: "No spam, no resharing your email. Unsubscribe in a single click whenever you like." },
];

export default function Club() {
  return (
    <div data-testid="club-page">
      <section className="border-b border-border bg-[radial-gradient(ellipse_at_top,_hsl(36_30%_92%)_0%,_hsl(38_33%_96%)_60%)]">
        <div className="container-page py-20 sm:py-28 text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-muted-foreground mb-6 ornament">
            <span>The readers&apos; club</span>
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-balance">
            Between The Lines.
          </h1>
          <p className="mt-7 text-base sm:text-lg text-muted-foreground leading-relaxed italic max-w-2xl mx-auto">
            A monthly letter from Soft Spine Press for readers who like to linger. Subscribe for a thoughtful note, members-only offers, and the occasional free sampler.
          </p>
          <div className="mt-10 max-w-xl mx-auto">
            <NewsletterForm source="club_page" />
            <p className="mt-3 text-xs text-muted-foreground italic">Free to join · one letter a month · unsubscribe anytime.</p>
          </div>
        </div>
      </section>

      <section className="container-page py-20">
        <div className="text-center mb-12">
          <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-muted-foreground ornament inline-block">What members receive</div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {PERKS.map((p, i) => (
            <div key={p.title} className="border border-border rounded-sm p-6 bg-card" data-testid={`perk-${i}`}>
              <div className="h-9 w-9 rounded-sm bg-muted flex items-center justify-center text-accent mb-4"><p.icon className="h-4 w-4" strokeWidth={1.5} /></div>
              <div className="font-display text-xl tracking-tight">{p.title}</div>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-page pb-24">
        <blockquote className="max-w-3xl mx-auto text-center">
          <div className="font-display text-2xl sm:text-3xl italic leading-snug text-balance">
            &ldquo;A book begins on the page, but it ends in the reader. Between the lines is where the real story lives.&rdquo;
          </div>
          <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mt-5">— Soft Spine Press</div>
        </blockquote>
        <div className="text-center mt-10">
          <Link to="/browse" className="text-sm font-medium hover:text-accent uppercase tracking-wide">Browse the catalogue →</Link>
        </div>
      </section>
    </div>
  );
}
